export const MAX_BULK_DRAFT_ORDERS = 1500;
